module.exports = __webpack_public_path__ + "static/media/Debit-dose-etiquettes.d940f996.png";